import api from 'api/apiInstance';
import { mapFormData } from 'helpers/formData';
import { objectToURLParams } from 'helpers/utils';

interface PracticeSettingsPreviewPdfGetOptions {
  fontName: string;
}

export function practiceSettingsPreviewPdfApi(path: string) {
  const generatePath = (params?: PracticeSettingsPreviewPdfGetOptions) =>
    params ? `${path}?${objectToURLParams(mapFormData(params))}` : path;

  return {
    path,
    GET: (params?: PracticeSettingsPreviewPdfGetOptions) => api.get(generatePath(params)),
    GETPath: (params?: PracticeSettingsPreviewPdfGetOptions) => generatePath(params),
  };
}
